import React from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { showError } from '../../../../core/alert/sweetAlertConfig';

interface FloorDTO {
  id: number;
  name: string;
  floorNumber: number;
  buildingId: number;
  buildingName: string;
  locationName: string;
  createdBy: string;
  createdAt: string;
  updatedBy?: string;
  updatedAt?: string;
}

interface ViewFloorModuleProps {
  show: boolean;
  onHide: () => void;
  floor: FloorDTO | null;
}

const ViewFloorModule: React.FC<ViewFloorModuleProps> = ({
  show,
  onHide,
  floor,
}) => {
  if (!floor) {
    showError('No floor data available. Please try again.');
    return null;
  }

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>View Floor: {floor.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="floorId">
                <Form.Label>ID</Form.Label>
                <Form.Control type="text" value={floor.id} disabled />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="floorName">
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" value={floor.name} disabled />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="floorNumber">
                <Form.Label>Floor Number</Form.Label>
                <Form.Control type="number" value={floor.floorNumber} disabled />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="buildingName">
                <Form.Label>Building</Form.Label>
                <Form.Control type="text" value={floor.buildingName} disabled />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="locationName">
                <Form.Label>Location</Form.Label>
                <Form.Control type="text" value={floor.locationName} disabled />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="createdBy">
                <Form.Label>Created By</Form.Label>
                <Form.Control type="text" value={floor.createdBy} disabled />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="createdAt">
                <Form.Label>Created At</Form.Label>
                <Form.Control
                  type="text"
                  value={new Date(floor.createdAt).toLocaleString()}
                  disabled
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="updatedAt">
                <Form.Label>Updated At</Form.Label>
                <Form.Control
                  type="text"
                  value={
                    floor.updatedAt
                      ? new Date(floor.updatedAt).toLocaleString()
                      : '-'
                  }
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-end mt-3">
            <Button variant="primary" onClick={onHide}>
              Close
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ViewFloorModule;
